export default __webpack_public_path__ + "static/media/promo-muggle-murders-rise_02.f3a5c3f5.jpg";